import { apiService } from "@/_services";

/**
 * Retrieves the spot table price for a commodity, from an API call.
 *
 * @param {number} commodityNumber - The unique number identifying the commodity.
 * @returns {Promise<object>} A promise that resolves to the spot price data for the specified commodity.
 * @throws {Error} If the API request fails or the commodity number is invalid.
 */
export function getCommodityTable(commodityNumber) {
  // Define the API request parameters for fetching spot price data.
  const params = {
    method: "GET", // HTTP method for the request.
    endpoint: "commodity_table", // API endpoint for commodity spot price data.
    content_type: "application/json", // Expected content type for the response.
    query_params: {
      format: "json", // Response format (JSON).
      commodity: commodityNumber // Commodity identifier passed as a query parameter.
    }
  };

  // Fetch the spot price data from the API using the apiService.
  return apiService.getAll(params);
}
